import React from 'react';
import HlidacForm from '../components/HlidacForm';

const hlidac = () => <HlidacForm />;

export default hlidac;
